import React from "react";
import CustomModal from "../../common/CustomModal";
import { Button } from "../../ui/button";
import { LuFileSpreadsheet } from "react-icons/lu";
import { RiAdvertisementLine } from "react-icons/ri";
import { SiGooglesheets } from "react-icons/si";

const DEFAULT_LABELS = {
  bulk: "Create bulk requests",
  sheet: "Import from Google Sheets",
  single: "Create a single ad request",
};

const CreateAdRequestChoiceModal = ({
  open,
  onClose,
  onUploadExcel,
  onCreateSingle,
  onSheetImport,
  title = "Create ad request",
  labels = DEFAULT_LABELS,
}) => {
  return (
    <CustomModal
      open={open}
      title={title}
      onClose={onClose}
      isButtonsRequired={false}
    >
      <div className="flex flex-col gap-3 py-2">
        <Button
          variant="outline"
          className="w-full justify-start h-12 text-left"
          onClick={() => {
            onClose();
            onUploadExcel?.();
          }}
        >
          <LuFileSpreadsheet className="w-5 h-5 mr-3 shrink-0" />
          {labels.bulk}
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start h-12 text-left"
          onClick={() => {
            onClose();
            onSheetImport?.();
          }}
        >
          <SiGooglesheets className="w-5 h-5 mr-3 shrink-0" />
          {labels.sheet}
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start h-12 text-left"
          onClick={() => {
            onClose();
            onCreateSingle?.();
          }}
        >
          <RiAdvertisementLine className="w-5 h-5 mr-3 shrink-0" />
          {labels.single}
        </Button>
      </div>
    </CustomModal>
  );
};

export default CreateAdRequestChoiceModal;
